import { RestUrl } from "../common/cyan.types";

export class DocumentSignMergeUrl {
  public static mergeDocumentSignWithCertificateBySignerToken: (signerToken: string) => RestUrl = signerToken => [
    "POST",
    `/document-signs/signer-token/${signerToken}/merge`,
  ];

  public static mergeDocumentSignWithCertificateByAuth: (documentSignId: bigint) => RestUrl = documentSignId => [
    "POST",
    `/document-signs/${documentSignId}/merge`,
  ];

  public static getDocumentSignMergeStatus: (fileExportHistoryId: bigint) => RestUrl = fileExportHistoryId => [
    "GET",
    `/file-export-histories/${fileExportHistoryId}/status`,
  ];

  public static downloadDocumentSignWithCertificateBySignerToken: (fileExportHistoryId: bigint, token: string) => RestUrl = (
    fileExportHistoryId,
    token
  ) => ["POST", `/file-export-histories/${fileExportHistoryId}/signer-token/${token}/merged-document/download`];

  public static downloadDocumentSignWithCertificateByAuth: (fileExportHistoryId: bigint) => RestUrl = fileExportHistoryId => [
    "POST",
    `/file-export-histories/${fileExportHistoryId}/merged-document/download`,
  ];
}
